import { Tooltip } from 'core/components/common/Tooltip'
import { IPromptHistory } from 'core/interfaces/PromptHistory'
import { truncateFilename } from 'core/utils/utils'
import { ReactComponent as PromptIcon } from 'lauria/assets/images/prompts/promptIcon.svg'
import { NbDocIcon } from 'lauria/components/common/NbDocIcon'
import { TemperatureSlider } from 'lauria/components/common/TemperatureSlider'
import { PromptModeleTag } from 'lauria/components/prompts/PromptModeleTag'

export const PromptHistoryCard = ({
  promptHistory,
}: {
  promptHistory: IPromptHistory
}) => {
  return (
    <div className="prompt-history-card">
      <div className="prompt-history-card-header">
        <PromptIcon className="dark:text-gray-1325 min-w-[45px] min-h-[45px]" />
        <div className="flex flex-col gap-y-[5px]">
          <div>{promptHistory.nomPromptHistorise}</div>
          <div className="flex flex-row items-center gap-x-[10px]">
            {promptHistory.modeleHistorise && (
              <PromptModeleTag modele={promptHistory.modeleHistorise} />
            )}
            <TemperatureSlider
              value={promptHistory.temperatureHistorise ?? 0.5}
              withLegend={false}
            />
            {promptHistory.documents?.length ? (
              <Tooltip
                className="prompt-history-card-tooltip"
                text={promptHistory.documents
                  .map((d) => truncateFilename(d.nomDocument))
                  .join('\n')}
              >
                <div className="relative group hover:cursor-pointer">
                  <NbDocIcon nbDoc={promptHistory.documents.length} />
                </div>
              </Tooltip>
            ) : (
              <div>
                <NbDocIcon nbDoc={0} />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="trait"></div>
      <div>{promptHistory.promptHistorise}</div>
    </div>
  )
}
